import { DotLegalMultiSelect } from "@dotlegal/dotlegal-ui-components";
import React from "react";
import { useTranslation } from "../../../localization/useTranslation.ts";
import useCountryHook from "../../../common/hooks/useCountryList.ts";

export interface SystemDataStorageLocationsFieldProps {
    dataStorageLocations: Array<string>;
    onChange: (locations: Array<string>) => void;
    readOnly?: boolean;
    disabled: boolean;
    errorText?: string;
}

function SystemDataStorageLocationsField(props: SystemDataStorageLocationsFieldProps) {
    const { translateString } = useTranslation();
    const { selectableCountries, countriesIsLoading } = useCountryHook();

    return (
        <DotLegalMultiSelect
            isLoading={countriesIsLoading}
            options={selectableCountries}
            chosenOptions={props.dataStorageLocations}
            onChange={props.readOnly ? () => {} : (countries) => props.onChange(countries)}
            placeholder={translateString("storageLocation")}
            label={translateString("storageLocation")}
            toolTipText={translateString("systemStorageTooltip")}
            noOptionsLabel={translateString("noOptions")}
            disabled={props.disabled}
            errorText={props.errorText}
        />
    );
}

export default SystemDataStorageLocationsField;
